<script setup lang="ts">
import type { FieldProps } from './interface'
import { FormControl, FormDescription, FormField, FormItem, FormMessage } from '@/components/ui/form'
import AutoFormLabel from './AutoFormLabel.vue'
import { beautifyObjectName } from './utils'
// import { cn } from '@/lib/utils'
import {
  getBrowserLocale,
  getCountriesList,
  // getCountryName
} from '@/ui-plus/PhoneNumber/basePhoneInput/helpers/use-phone-input';
// import { Button } from '@/components/ui/button';
// import { ChevronsUpDown } from 'lucide-vue-next';
import FlagComponent from '@/ui-plus/PhoneNumber/FlagComponent.vue';
// import { buttonVariants } from '@/components/ui/button';
const locale = getBrowserLocale()?.browserLocale ?? 'en-US'
defineProps<FieldProps>()

</script>

<template>
  <FormField v-slot="slotProps"
             :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel"
                     :required="required">
        {{ config?.label || beautifyObjectName(label ?? fieldName) }}
      </AutoFormLabel>
      <FormControl>
        <!-- <select :value="slotProps.componentField.modelValue"
                :disabled="config?.inputProps?.disabled"
                v-bind="{ ...slotProps.componentField, ...config?.inputProps }"
                :class="cn(buttonVariants({ variant: 'outline' }), ' w-full h-full')"
                @change="(e) => slotProps.setValue((e.target as HTMLSelectElement).value)">
          <option value=""
                  disabled>Select country...</option>
          <option v-for="option in getCountriesList(locale)"
                  :key="option.iso2"
                  :value="option.iso2">
            {{ option.name }}
          </option>
        </select> -->
        <div class="relative">
          <!-- <Button type="button"
                  variant="outline"
                  :disabled="config?.inputProps?.disabled"
                  :class="cn('flex gap-1 w-full justify-between px-3 pointer-events-none', config?.inputProps?.class)">
            <span class="flex items-center gap-2">
              <FlagComponent :country="slotProps.componentField.modelValue" />
              <span v-if="slotProps.componentField.modelValue"
                    class="flex-1 text-sm text-left">
                {{ getCountryName(locale, slotProps.componentField.modelValue) }}
              </span>
            </span>
            <ChevronsUpDown class="h-4 w-4 opacity-50 shrink-0" />
          </Button> -->
          <span class="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
            <FlagComponent :country="slotProps.componentField.modelValue" />
          </span>
          <select :value="slotProps.componentField.modelValue"
                  :disabled="config?.inputProps?.disabled"
                  v-bind="{ ...slotProps.componentField, ...config?.inputProps }"
                  class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-10"
                  @change="(e) => slotProps.setValue((e.target as HTMLSelectElement).value)">
            <option value=""
                    disabled>Select country...</option>
            <option v-for="option in getCountriesList(locale)"
                    :key="option.iso2"
                    :value="option.iso2">
              {{ option.name }}
            </option>
          </select>
        </div>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
